import Footer from "components/Organisms/Footer";
import Header from "components/Organisms/Header";
import React from "react";
import styled, { keyframes } from "styled-components";
import Lottie from "react-lottie";
import loadingLottie from "assets/lottie/404.json";
import ButtonCustom from "components/Atoms/Button";
import { useNavigate } from "react-router-dom";
import { PAGE } from "constants/page";

const defaultOption = (data) => {
  return {
    loop: true,
    autoplay: true,
    animationData: data,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
};

const SpaceContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const animateStar = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100vh);
  }
`;

const Star = styled.div`
  position: absolute;
  width: 2px;
  height: 2px;
  background: white;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  animation: ${animateStar} ${(props) => props.duration}s linear infinite;
`;

const Main = styled.div`
    width: 100%;
    height: 80vh;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    >p {
      margin-top: -50px;
      font-size: 32px;
      @media (max-width: 1024px) {
        margin-top: -20px;
        font-size: 18px;
      }
    }
`
const generateStars = (count) => {
  let stars = [];
  for (let i = 0; i < count; i++) {
    stars.push(
      <Star
        key={i}
        top={Math.random() * -100}
        left={Math.random() * window.innerWidth}
        duration={Math.random() * 20 + 2}
      />
    );
  }
  return stars;
};

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <SpaceContainer>{generateStars(100)}</SpaceContainer>
      <div className="container">
        <Main>
          <Lottie options={defaultOption(loadingLottie)} style={{ height: 'fit-content', width: 'fit-content' }} />
          <p>P A G E &nbsp;&nbsp;&nbsp; N O T &nbsp;&nbsp;&nbsp; F O U N D</p>
          <ButtonCustom type='white' onClick={() => navigate(PAGE.home)}>Back to homepage</ButtonCustom>
        </Main>
      </div>
      <Footer />
    </>
  );
};

export default NotFoundPage;









